const equipmentBadgeStatus = {
  inactive: 'Inactive',
  maintenance: 'Maintenance',
  valid: 'Valid',
  invalid: 'Invalid',
  validWithOpenedActions: 'Valid*',
};

export default equipmentBadgeStatus;